module.exports = __webpack_public_path__ + "static/aside.box-fa5979c15d8e01b3ef58699eb958a0e6.png";